import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Small "← Back to Administration" link for admin destinations reached from the
// /admin hub (Users, Timetable, Templates, Materials). Defaults to /admin but
// `to`/`labelKey` are overridable — the draft board points back at /timetable.
// One per DESTINATION: the timetable workspace renders it once in its shell,
// not once per tab panel.
export default function BackLink({ to = "/admin", labelKey = "common.backToAdmin" }) {
  const { t } = useTranslation();
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 transition hover:text-indigo-600 focus-visible:outline-none focus-visible:text-indigo-600"
    >
      <svg
        className="h-4 w-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth="2.2"
        aria-hidden="true"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
      {t(labelKey)}
    </Link>
  );
}
